/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect, useContext, useState } from "react";
import { Navigate, Routes, Route, useLocation, useNavigate } from "react-router-dom";
// import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
//import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import ContextApp from "../core/contexts/context.app";
import Login from "./pages/_Components/Login";
import Logout from "./pages/_Components/Logout";
import ServiceApi from "../core/services/service.api";

// there urls havent any pagination 
const excluedPageInation = [
  "/",
  "/dashboard",
  "/changepassword",
  "/cachemanager",
  "/reservationform",
  "/reservationform2",
  "/reservationformdescription",
  "/aboutus",
  "/reportselltransaction",
  "/reportbuytransaction",
  "/createoreditservice",
  "/createoreditplace",
  "/viewnewbasketcontents",
  "/viewordercontents",
  "/viewcanceledordercontents",
  "/userwithdrawalsdetails",
  "/createeditamusementservicepromocategorycommision",
  "/createeditamusementservicepromocategory",
  "/createeditamusementcomplex",
  "/editagentcommissionitems",
  "/amusementdescription",
  "/canceled",
  "/contact",
  "/login",
  "/sellcharts",
  "/logout"
]

function ProtectedRoute({ isAuthorized, children }) {
  return isAuthorized ? children : <Navigate to="/login" replace />;
}
export function Routes2() {
  let location = useLocation();
  let navigate = useNavigate();
  const ctx = useContext(ContextApp);
  let isAuthorized = ServiceApi.hasToken();
  // store last page pathname for compare
  const [lastPagePath, setLastPagePath] = useState("/")

  useEffect(() => {
    //بهتر از استورج گرفته شود تا در تمام صفحات مرورگر یکسان باشد
    isAuthorized = ServiceApi.hasToken();
    if (isAuthorized != ctx.isAuth && !isAuthorized) {
      ctx.setIsAuth(isAuthorized);
    }
    // mainPath is first pathname in url ex: /createOrEditService/9167 => mainPath is /createOrEditService
    const mainPatch = ("/" + location.pathname.substr(1).split("/")[0]).toLowerCase()
    // if url pathanme has 2 path, its not a listpage its detail page ex: /createOrEditService/9167 has 2 path in pathname
    const checkListPageOrNot = location.pathname.substr(1).split("/").length > 1
    // if pathname doesnt exist in excluedPageInation & page pathname hasnt 2 path & path include in server go to navigation query
    // but some page maybe dont need pagination like /login
    if (!excluedPageInation.includes(mainPatch) && !checkListPageOrNot && isAuthorized) {
      // if navigate to new page, navigation query reset!
      // but navigate again to old page again navigation doesnt reset !
      if (location.pathname != lastPagePath && !location.search) {
        let params = `${location.pathname}?pageNumber=1&pageSize=10`
        if (location.pathname.includes("userWithdrawals")) params += "&sortBy=1"
        else if (location.pathname.includes("reportSell")) params += "&sortBy=1"
        navigate(params);
      }
      else
        navigate(`${location.pathname}${location.search}`);

    }
    //if path include in server
    if (ctx.menu.includes(mainPatch) && isAuthorized)
      // set Last page for compare new page with old page
      setLastPagePath(location.pathname)
  }, [location.pathname]);

  // const {isAuthorized} = useSelector(
  //     ({auth}) => ({
  //         isAuthorized: auth.user != null,
  //     }),
  //     shallowEqual
  // );

  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/error" element={<ErrorsPage />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="*"
        element={
          <ProtectedRoute isAuthorized={isAuthorized}>
            <Layout>
              <BasePage />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
